/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { log } from 'src/consoleManager';
import postBeacon from 'src/networkManager';
import { getAppSessionId, secondsToDays, getNextDateTime } from 'src/utils';
import { SESSION_STORAGE_TYPE } from 'src/utils/enum';
import { getSDKConfig } from 'src/utils/config';
let priorityMaxRetriesCount = 5; // Number of retries for priority events from
let priorityRemainingRetriesCount = 5;
let priorityRetryBackoff = 500; // Retry delay in milliseconds (2 second)
let priorityDiscardOnFailure = false; // Do not discard priority events if retries fail
let priorityMaxBeaconsPerMinute = 120; // Maximum number of beacons allowed per minute
let priorityOfflineCacheFlushInterval = 7; //Flush offline cache every 7 days in seconds
const withOutLocalStorePriorityProcessQueue = () => {
  if (
    window.spnGlobalConfig.spnBeaconNetworkStatus &&
    window.spnGlobalConfig.priorityBeaconExecutionStart == false
  ) {
    priorityConfigUpdate();
    withOutLocalStorePriorityExecuteLocalStorage();
  }
};

const priorityConfigUpdate = () => {
  const sdkConfig = getSDKConfig();
  priorityMaxRetriesCount = sdkConfig?.priority?.max_retries || 5;
  priorityRemainingRetriesCount = sdkConfig?.priority?.max_retries || 5;
  priorityRetryBackoff = 500;
  priorityDiscardOnFailure = sdkConfig?.priority?.discard_on_failure || false;
  const OfflineDays =
    sdkConfig?.priority?.offline_cache_flush_interval || 604800;
  const finalDays = secondsToDays(OfflineDays);
  priorityOfflineCacheFlushInterval = finalDays;
  priorityMaxBeaconsPerMinute =
    sdkConfig?.general?.rate_limit?.max_beacons_per_minute || 120;
  if (sdkConfig?.general?.rate_limit?.enabled == true) {
    const burstLimit = sdkConfig?.general?.rate_limit?.burst_limit || 50;
    priorityMaxBeaconsPerMinute += burstLimit;
  }
  priorityRemainingRetriesCount -= 1;
};

// current storage Execution
const withOutLocalStorePriorityExecuteLocalStorage = () => {
  try {
    if (
      window.spnGlobalConfig?.maxRecordPerMinute >= priorityMaxBeaconsPerMinute
    ) {
      window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      return;
    }
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (window.spnGlobalConfig.priorityBeaconExecutionStart) {
      return;
    }
    const sessionId = SESSION_STORAGE_TYPE.priority + getAppSessionId();
    if (window.spnGlobalConfig?.priorityStoreRecordData?.length == 0) {
      window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      return;
    }
    const currentTime = parseInt(
      window.spnGlobalConfig?.priorityStoreRecordData[0]?.currentTime
    );
    const payLoadBody =
      window.spnGlobalConfig?.priorityStoreRecordData[0]?.payLoadBody;
    const eventType =
      window.spnGlobalConfig?.priorityStoreRecordData[0]?.eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      priorityOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
      priorityHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
          priorityHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
        })
        .catch((e) => {
          log(e);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            priorityCleanCurrentSessionBeacons(apiResponse, sessionId);
            priorityHandleCurrentSessionNextBeaconExecute(
              apiResponse,
              sessionId
            );
            //window.spnGlobalConfig.priorityBeaconExecutionStart = true;
          }
        });
    }
  } catch (e) {
    log(e);
    window.spnGlobalConfig.priorityBeaconExecutionStart = true;
  }
};

const priorityCleanCurrentSessionBeacons = (apiResponse, sessionId) => {
  try {
    //apiResponse == 200 || apiResponse == 0 &&
    const removeFromQueue = getRecordRemoveStatus(apiResponse);
    if (removeFromQueue) {
      if (window.spnGlobalConfig?.priorityStoreRecordData?.length > 0) {
        window.spnGlobalConfig?.priorityStoreRecordData?.shift();
      }
    }
  } catch (error) {
    log(error);
  }
};

const priorityHandleCurrentSessionNextBeaconExecute = (
  apiResponse,
  sessionId
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      const intervalTime = apiResponse == 0 ? priorityRetryBackoff : 500;
      // when beacons pass
      if (
        window.spnGlobalConfig?.priorityStoreRecordData.length > 0 &&
        window.spnGlobalConfig?.priorityBeaconExecutionStart == false
      ) {
        setTimeout(() => {
          withOutLocalStorePriorityExecuteLocalStorage();
        }, intervalTime);
      } else {
        window.spnGlobalConfig.priorityBeaconExecutionStart = true;
      }
    }
  } catch (error) {
    log(error);
  }
};

const getRecordRemoveStatus = (apiResponse) => {
  let removeFromQueue = false;
  if (apiResponse == 0 && priorityRemainingRetriesCount > 0) {
    removeFromQueue = false;
    priorityRemainingRetriesCount -= 1;
  } else {
    removeFromQueue = true;
    priorityRemainingRetriesCount = priorityMaxRetriesCount - 1;
  }
  if (apiResponse == 200) {
    removeFromQueue = true;
    priorityRemainingRetriesCount = priorityMaxRetriesCount - 1;
  }
  if (priorityDiscardOnFailure) {
    removeFromQueue = true;
  }
  return removeFromQueue;
};

export {
  withOutLocalStorePriorityProcessQueue,
  withOutLocalStorePriorityExecuteLocalStorage,
};
